import React from "react";

import { Form, FormItemProps } from "antd";

import "@/common/FilterSelect/FilterSelect.scss";

interface FilterSelectItemProps extends FormItemProps {
  children: React.ReactNode;
}

const FormItem = (props: FilterSelectItemProps) => {
  const {
    children,
    name,
    validateTrigger,
    label,
    layout = "vertical",
    className,
    rules,
  } = props;

  return (
    <Form.Item
      style={{ width: "100%" }}
      className={className}
      name={name}
      validateTrigger={validateTrigger}
      label={label}
      layout={layout}
      rules={rules}
    >
      {children}
    </Form.Item>
  );
};

export default FormItem;
